import React, { Component } from 'react';
import CONF from '../../../../config/config.js';
import Typehead from './../../../../commons/Typehead.js';
import FileUploader from './../../../../commons/FileUploader.js';
import PDFViewer from './../../../../commons/PDFViewer.js';
import InwardingApiHandler from './../../InwardingApiHandler.js';
import ListingProduct from './ListingProduct.js';
import Dialog from '@material-ui/core/Dialog';
import ErrorBox from './../../../../commons/ErrorBox';
import MobLoader from './../../../../commons/MobLoader.js';
import close from './../../../../assets/img/close.png';
import info from './../../../../assets/img/info-button.png';
import filled_tick from './../../../../assets/img/filled_tick.png';
import InputFloating from './../../../../commons/InputFloating.js';
import Popover from '@material-ui/core/Popover';
import barcode_error from './../../../../assets/img/barcode_error.svg';
import Collapse from '@material-ui/core/Collapse';
import SelectParent from './AddPalletUI/SelectParent.js';
import SelectFreebie from './AddPalletUI/SelectFreebie.js';
import { sendEventToHevo } from '../../../../utilities/manageEvents.js';

export default class AddPallet extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
			vinv: null,
			vendorInvoice: null,
			addedProducts: [],
			allowedProducts: [],
			confirmScanning: false,
			spaceBarcode: '',
			selectedSpace: null,
			spaceError: null,
			requestOffloadingDone: false,
			podDocId: null,
			showDocumentSummary: false,
			offloadingDone: false,
			palletId: null,
			palletDropedSuccessfully: false,
			anchorEl: null,
			optionsPopOver: false,
			alreadyInwarded: [],
			productVerificationBox: false,
			noProductFoundWithBarcode: false,
			productPickerBox: false,
			productPickerList: [],
			inw_open: false,
			uniqueJpinsReceived: [],
			uniqueJpinsInPO: [],
			allowedProducts2: [],
			receiveNewProducts: false,
			receiveNewProductsReason: '',
			receiveNewProductsStep: 1,
			freebieJpin: '',
			parentListingSelected: '',
			parentListingTitle: ''
		}
	}

	sendEvent = (eventName, eventData) => {
		if (!eventName || !eventData) {
			console.error('some parameter not passed in event');
			return;
		}
		let req = { ...eventData };
		sendEventToHevo(eventName, req);
	}

	closeError = () => {
		this.setState({ error: null })
	}

	fetchProductsForInvoice = (vinv) => {
		this.setState({ loading: true });
		InwardingApiHandler.getProductsForVendorInvoice(vinv)
			.then(resp => {
				//call this api after we get data from above api
				this.fetchPalletInfo(vinv, resp);

				const unique_jpins_from_po = resp.map((ele) => {
					return ele.productListingInformation.productInfoResponse.jpin;
				})

				const resp2 = resp.filter((ele) => {
					return ele.underProcessQty > 0;
				})

				this.setState({ allowedProducts: resp, allowedProducts2: resp2, uniqueJpinsInPO: unique_jpins_from_po });
			}).catch(error => {
				this.setState({ error: error.error.error, loading: false });
			})
	}

	fetchVendorInvoiceById = (vinv) => {
		InwardingApiHandler.getInoiceDeatilsById(vinv)
			.then(resp => {
				this.setState({ vendorInvoice: resp });
			}).catch(error => {
				this.setState({ error: error.error.error });
			}).finally(() => {
				//this.setState({loading: false});
			})
	}

	getSpaceByBarcode = () => {
		const { spaceBarcode } = this.state;
		InwardingApiHandler.getSpaceByBarcode(spaceBarcode)
			.then(resp => {
				this.validateAndShowSpace(resp);
			}).catch(error => {
				this.setState({ error: error.error.error });
			}).finally(() => {

			})
	}

	offloadingComplete = () => {
		this.setState({ loading: true });
		const { podDocId, vinv } = this.state;
		let req = {
			podUrl: podDocId,
			vendorInvoiceId: vinv
		}
		InwardingApiHandler.uploadPod(req)
			.then(resp => {
				this.setState({ offloadingDone: true });
			}).catch(error => {
				this.setState({ error: error.error.error });
			}).finally(() => {
				this.setState({ loading: false });
			})
	}

	fetchPalletInfo = (vinv, resp1) => {
		//this.setState({loading: true});
		InwardingApiHandler.fetchPalletInfo(vinv)
			.then(resp => {

				//resp.goodsReceivedItemResponseList array can contain multiple objects with same lsitingIds
				//here we are clubbing the objects in the array with same listingIds 
				//clubbing means adding up the quantities for same listing Ids

				let s = new Set();
				let s_jpin = new Set();
				let qty_for_unique_key = {};
				resp.goodsReceivedItemResponseList2 = [];

				resp.goodsReceivedItemResponseList.sort(function (a, b) { return (b.createdTime > a.createdTime) ? 1 : ((b.createdTime < a.createdTime) ? -1 : 0); });

				if (resp.goodsReceivedItemResponseList) {

					resp.goodsReceivedItemResponseList.forEach(function (ele) {
						if (ele.productInfoResponse && ele.listingDetailsResponse) {
							let title = ele.productInfoResponse.title;
							let lst = ele.listingDetailsResponse.listingDetails.listingId;
							let jpin = ele.productInfoResponse.jpin;
							let isFreebie = ele.freebie;

							if (!isFreebie && jpin) {
								if (!s_jpin.has(jpin)) {
									s_jpin.add(jpin);
								}
							}

							let unique_key = title + lst + jpin + isFreebie;
							if (s.has(unique_key)) {
								qty_for_unique_key[unique_key] = qty_for_unique_key[unique_key] + ele.qty;
							}
							else {
								s.add(unique_key);
								qty_for_unique_key[unique_key] = ele.qty;
								resp.goodsReceivedItemResponseList2.push(ele);
							}
						}
					})
					//console.log(s);
					resp.goodsReceivedItemResponseList2.forEach(function (ele) {
						let lst = null, jpin = null, isFreebie = null, title = null;
						if (ele.productInfoResponse && ele.listingDetailsResponse) {
							title = ele.productInfoResponse.title;
							lst = ele.listingDetailsResponse.listingDetails.listingId;
							jpin = ele.productInfoResponse.jpin;
							isFreebie = ele.freebie;
						}

						let unique_key = title + lst + jpin + isFreebie;
						ele.qty = qty_for_unique_key[unique_key];

						let obj = resp1.find(function (ele2) {
							return ele2.productListingInformation.productInfoResponse.jpin === jpin;
						})

						if (obj) {
							if (obj && obj.underProcessQty && obj.underProcessQty > 0) {
								ele.shortInward = true;
							}
							else if (obj && obj.underProcessQty === 0) {
								ele.shortInward = false;
							}
						}

					})
				}

				this.setState({ palletId: resp.goodsReceivedItemContainerId, addedProducts: resp.goodsReceivedItemResponseList2, uniqueJpinsReceived: [...s_jpin] });
			}).catch(error => {
				this.setState({ error: error.error.error });
			}).finally(() => {
				this.setState({ loading: false });
			})
	}

	dropPallet = () => {
		this.setState({ loading: true });
		const { palletId, selectedSpace } = this.state;
		var req = {
			goodsReceivedItemContainerId: palletId,
			spaceId: selectedSpace.spaceId
		}
		InwardingApiHandler.dropPallet(req)
			.then(resp => {
				this.setState({ palletDropedSuccessfully: true });
			}).catch(error => {
				this.setState({ error: error.error.error });
			}).finally(() => {
				this.setState({ loading: false });
			})
	}

	fetchAlreadyInwardedProducts = (vinv) => {
		InwardingApiHandler.fetchAlreadyInwardedProducts(vinv)
			.then(resp => {
				this.setState({ alreadyInwarded: resp });
			}).catch(error => {

			}).finally(() => {

			})
	}


	validateAndShowSpace = (space) => {
		var allowedPurposes = ["INWARDING", "INWARDING_STAGING", "INWARDING_OFFLOADING"];
		if (allowedPurposes.includes(space.spaceUsagePurpose)) {
			this.setState({ selectedSpace: space });
			this.closeBarcodeBox();
		} else {
			let error = "You can not inward in " + space.spaceUsagePurpose + " area .";
			this.setState({ spaceError: error });
		}
	}


	componentDidMount() {
		const { vinv } = this.props.match.params;
		this.setState({ vinv: vinv });
		this.fetchProductsForInvoice(vinv);
		this.fetchVendorInvoiceById(vinv);
		this.fetchAlreadyInwardedProducts(vinv);
	}

	getReceivedQty = (product) => {
		//get already received quantity for selected product (already inwarded + already on pallet)
		const { alreadyInwarded, addedProducts } = this.state;
		const x = alreadyInwarded.find((ele) => {
			let isPresent = false;
			if (ele.listingDetailsResponse && ele.listingDetailsResponse.listingDetails) {
				if (ele.listingDetailsResponse.listingDetails.listingId === product.productListingInformation.listingId) {
					isPresent = true;
				}
			}

			return isPresent;
		})

		const y = addedProducts.find((ele) => {
			let isPresent = false;
			if (ele.listingDetailsResponse && ele.listingDetailsResponse.listingDetails) {
				if (ele.listingDetailsResponse.listingDetails.listingId === product.productListingInformation.listingId) {
					isPresent = true;
				}
			}

			return isPresent;
		})


		let total = 0;
		if (x) {
			total += x.qty;
		}
		if (y) {
			total += y.qty;
		}

		return total;
	}

	onSelection = (product, scanned) => {
		const { vinv, palletId, allowedProducts, scannedBarcode, barcodeMatchStatus } = this.state;
		if (product.productListingInformation) {
			let x = product.productListingInformation;
			let req = {
				listing_id: x.listingId,
				mrp: x.mrp,
				jpin: x.productInfoResponse.jpin,
				product_name: x.productInfoResponse.title,
				inwarding_session_id: vinv,
				gric: palletId
			};

			this.sendEvent('ON_SELECT_INWARD_PRODUCT', req);
			req['scanned'] = scanned;
			this.sendEvent('ON_SEARCH_PRODUCT_BY_TYPE_OR_SCAN', req);
		}

		let inw_qty = this.getReceivedQty(product);
		let pathdir;
		let state = {
			vinv: vinv,
			product: product.productListingInformation,
			palletId: palletId,
			allowedProducts: allowedProducts,
			receivedQuantity: inw_qty
		};
		if (product.productListingInformation.barCodeRequired && barcodeMatchStatus !== 'PRESENT_IN_PO_CORRECT_MATCH') {
			pathdir = 'BarcodeMapper';
		} else {
			pathdir = 'ProductDetails';
			if (scannedBarcode) {
				state.scannedBarcode = scannedBarcode;
				state.barcodeMatchStatus = barcodeMatchStatus;
			}
		}
		this.props.history.push({
			pathname: '/Inwarding/' + pathdir,
			state: state
		});
	}

	checkFreebieInwarded = () => {
		let req = [];
		req.push(this.state.vinv);

		this.setState({ loading: true });
		InwardingApiHandler.checkAllFreebiesInwarded(req)
			.then(resp => {
				console.log('check-freebie api successful');
				this.finishOffloading();
			}).catch(error => {
				console.log(error);
				this.setState({ error: error.error.error });
			}).finally(resp => {
				this.setState({ loading: false });
			})
	}

	showScanningWarning = () => {
		this.setState({ confirmScanning: true });
	}

	finishOffloading = () => {
		this.setState({ requestOffloadingDone: true, optionsPopOver: false });
	}

	updateSpaceBarcode = e => {
		this.setState({ spaceBarcode: e.target.value });
	}

	closeBarcodeBox = () => {
		this.setState({ confirmScanning: false });
	}

	handleUploadResponse = (resp) => {
		this.setState({ podDocId: resp });
	}

	onDeleteClick = () => {
		this.setState({ podDocId: null });
	}

	showInwarded = () => {
		this.setState({ showDocumentSummary: true, optionsPopOver: false });
	}

	closeDocumentSummary = () => {
		this.setState({ showDocumentSummary: false });
	}

	closeOffloadingDone = () => {
		this.setState({ offloadingDone: false });
		this.props.history.push({
			pathname: '/Inwarding'
		});
	}

	closePalletDropedSuccessfully = () => {
		this.setState({ palletDropedSuccessfully: false });
		window.location.reload();
		// this.props.history.push({
		//  pathname: '/Inwarding'
		// });
	}

	handleBarcodeSearchResponse = (resp, barcode) => {
		const { allowedProducts } = this.state;
		// The barcode lookup returns ALL SKUs mapped to the barcode (a single barcode can map to many
		// JPINs). Keep only the SKUs whose JPIN is on this PO, then let the operator pick when more than
		// one matches. Tolerate the legacy single-object shape too, so this is safe regardless of
		// backend deploy timing.
		const skus = Array.isArray(resp) ? resp : (resp && resp.jpin ? [resp] : []);
		const onPoSkus = skus.filter(sku =>
			allowedProducts.some(item =>
				item.productListingInformation.productInfoResponse.jpin === sku.jpin)
		);
		if (onPoSkus.length === 0) {
			const status = skus.length > 0 ? 'NOT_IN_PO' : 'NOT_FOUND';
			this.setState({ noProductFoundWithBarcode: true, scannedBarcode: barcode, barcodeMatchStatus: status });
		} else if (onPoSkus.length === 1) {
			this.openProductVerification(onPoSkus[0], barcode);
		} else {
			// Multiple PO-matched SKUs for this barcode — let the operator pick which one to verify.
			this.setState({ productPickerBox: true, productPickerList: onPoSkus, scannedBarcode: barcode });
		}
	}

	openProductVerification = (sku, barcode) => {
		const { allowedProducts } = this.state;
		const matchedListing = allowedProducts.find(item =>
			item.productListingInformation.productInfoResponse.jpin === sku.jpin);
		if (matchedListing) {
			this.setState({ productPickerBox: false, productVerificationBox: true, productToVerify: matchedListing, scannedBarcode: barcode });
		} else {
			this.setState({ productPickerBox: false, noProductFoundWithBarcode: true, scannedBarcode: barcode, barcodeMatchStatus: 'NOT_IN_PO' });
		}
	}

	closeProductPicker = () => {
		this.setState({ productPickerBox: false });
	}


	searchBarCode = (barcode) => {
		this.setState({ loading: true });
		InwardingApiHandler.searchBarCode(barcode)
			.then(resp => {
				this.handleBarcodeSearchResponse(resp, barcode)
			}).catch(error => {

			}).finally(resp => {
				this.setState({ loading: false });
			})
	}

	barcodedProductIsWrong = () => {
		this.setState({ productVerificationBox: false, barcodeMatchStatus: 'PRESENT_IN_PO_WRONG_MATCH' })
		document.getElementById('product_type_head').focus();
	}

	barcodedProductIsRight = () => {
		this.setState({ productVerificationBox: false, barcodeMatchStatus: 'PRESENT_IN_PO_CORRECT_MATCH' }, function () {
			this.onSelection(this.state.productToVerify, true);
		})
	}


	enteredPress = (barcode) => {
		if (!isNaN(barcode)) {
			this.searchBarCode(barcode);
		}
	}

	closeNotFoundErrorBox = () => {
		this.setState({ noProductFoundWithBarcode: false, shouldAskForBarcodeVerification: true })
		document.getElementById('product_type_head').focus();
	}

	backButtonClicked = () => {
		const { requestOffloadingDone, selectedSpace } = this.state;

		if (requestOffloadingDone) {
			this.setState({ requestOffloadingDone: false })
		} else if (selectedSpace) {
			this.setState({ selectedSpace: false })
		} else {
			window.history.back();
		}
	}

	showOptions = placement => event => {
		const { currentTarget } = event;
		this.setState(state => ({
			optionsPopOver: state.placement !== placement || !state.optionsPopOver,
			anchorEl: currentTarget
		}));
	};

	optionsClose = () => {
		this.setState({ optionsPopOver: false });
	}

	getHeaderBox = () => {
		const { selectedSpace, requestOffloadingDone, optionsPopOver, anchorEl, alreadyInwarded } = this.state;
		return (<div className="header-name-bar">
			<div className="row">
				<div className="col-xs-1">
					<div className="visible-xs visible-sm" style={{ lineHeight: '65px', fontSize: '25px' }} onClick={this.backButtonClicked}><i className="fas fa-arrow-left"></i></div>
				</div>
				<div className="col-xs-9">
					<div className="header-page-name">
						{(!selectedSpace && !requestOffloadingDone) ?
							<div>Inward Products</div>
							: (selectedSpace) ?
								<div>Inwarding Area</div>
								: (requestOffloadingDone) ?
									<div>Upload POD</div>
									: null
						}
					</div>
				</div>
				<div className="col-xs-2">
					{(!selectedSpace && !requestOffloadingDone) ?
						<div style={{ lineHeight: '65px', fontSize: '25px', textAlign: 'center' }} onClick={this.showOptions('top-right')}><i className="fas fa-ellipsis-v"></i></div> : null
					}
					<Popover open={optionsPopOver} anchorEl={anchorEl} onClose={this.optionsClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }} classes={{ paper: 'noOverflowHidden' }}>
						<div style={{ padding: '20px', color: '#000', fontSize: '16px', backgroundColor: '#fff' }}>
							<div onClick={this.checkFreebieInwarded}>Finish Inwarding Session</div>
							{(alreadyInwarded.length > 0) ?
								<div style={{ marginTop: '20px' }} onClick={this.showInwarded}>View Inwarded Products</div> : null
							}
						</div>
					</Popover>
				</div>
			</div>
		</div>)
	}


	showSpaceWithItems = () => {
		const { selectedSpace } = this.state;
		return (
			<div>
				<div className="search-box-outer">
					<div className="v-imp-txt">Space Scanned</div>
					<div className="top-ten space-name">{selectedSpace.spaceDisplayName}</div>
				</div>
				<div style={{ marginBottom: '80px' }}>
					{this.showAlreadyAddedProduct()}
				</div>
				<div className="btm-actn-br">
					<div className="row">
						<div className="col-xs-2"></div>
						<div className="col-xs-8"><button className="btn btn-big-blue" onClick={this.dropPallet}>Inward Products</button></div>
						<div className="col-xs-2"></div>
					</div>
				</div>
			</div>
		)
	}

	showUploadPOD = () => {
		const { podDocId, vendorInvoice } = this.state;
		return (
			<div>
				<div style={{ padding: '10px', marginBottom: '80px' }}>
					<div className="pod-box-wrapper">
						<div className="v-imp-txt">View Details</div>
						<div className="top-twenty">
							<div className="c-b-u">Facility Centre</div>
							<div className="pod-itm-big">{vendorInvoice.facilityBO.facilityName}</div>
							<div className="c-b-u">Vendor Name</div>
							<div className="pod-itm-big">{vendorInvoice.vendor.boltVendorDisplayName}</div>
							<div className="c-b-u">Seller Name</div>
							<div className="pod-itm-big">{vendorInvoice.orgName}</div>
							<div className="c-b-u">Invoice No.</div>
							<div className="pod-itm-big">{vendorInvoice.vendorInvoiceNumber}</div>
							<div className="c-b-u">Upload POD</div>
							<div className="top-ten">
								{(podDocId) ?
									<PDFViewer url={podDocId} onDeleteClick={this.onDeleteClick} />
									:
									<FileUploader 
										url="inwarding/upload" 
										noMessage="true" 
										handleUploadResponse={this.handleUploadResponse} 
										accept='.pdf' 
										fileSizeLimit={CONF.FILE_SIZE_LIMIT_FOR_PDF_IN_BYTES}
									/>
								}
							</div>
						</div>
					</div>
				</div>
				<div className="btm-actn-br">
					<div className="row">
						<div className="col-xs-2"></div>
						<div className="col-xs-8"><button className={"btn " + (podDocId ? 'btn-big-green' : 'btn-big-norm')} disabled={(podDocId ? false : true)} onClick={this.offloadingComplete}>Offloading Done</button></div>
						<div className="col-xs-2"></div>
					</div>
				</div>
			</div>
		)
	}

	getSpaceBarcodeEntryRender = () => {
		return (<div>
			<div style={{ fontSize: '16px', textAlign: 'center' }}>To Proceed</div>
			<div className="top-twenty">
				<InputFloating type="text" label="Enter Space Barcode" value={this.state.spaceBarcode} onChange={this.updateSpaceBarcode} />
			</div>
			<div style={{ height: '20px', color: '#de463a' }}>{this.state.spaceError}</div>
			<div style={{ textAlign: 'center' }}><button className="btn search-btn-blue" onClick={this.getSpaceByBarcode}>Confirm Barcode</button></div>
		</div>)
	}

	getXdividedByY = () => {
		const { uniqueJpinsReceived, uniqueJpinsInPO, alreadyInwarded, vendorInvoice, allowedProducts } = this.state;
		let x = uniqueJpinsReceived.length, y = 0;
		if (vendorInvoice) {
			//y = Math.min(vendorInvoice.numberOfItems, allowedProducts.length);
			y = vendorInvoice.numberOfItems;
		}

		alreadyInwarded.forEach((ele) => {
			let j = ele.productInfoResponse.jpin;
			if (!uniqueJpinsReceived.includes(j) && uniqueJpinsInPO.includes(j)) {
				x++;
			}
		})

		return [x, y];
	}

	showAlreadyAddedProduct = (x, y) => {
		const { addedProducts, allowedProducts, palletId } = this.state;
		//const [x, y] = this.getXdividedByY();

		return (<div style={{ padding: '10px' }}>
			{(x || y) ?
				<div className="v-imp-txt" style={{ display: 'flex', justifyContent: 'space-between' }}>
					<div>List of already received items </div>
					<div>{x}/{y}</div>
				</div>
				:
				null
			}

			<div className="top-ten">
				{
					addedProducts.map((prd, index) => {
						let p = {};
						let mOffer = prd.listingDetailsResponse.listingDetails.manufacturerOffer;;
						if (allowedProducts.length > 0) {
							p = allowedProducts.find((ele) => {
								return prd.productInfoResponse.jpin === ele.productListingInformation.productInfoResponse.jpin;
							})
						}

						return (
							<div key={index} className="top-ten">
								<ListingProduct product={prd} mOffer={mOffer} showQty={true} palletId={palletId} mrp={prd.listingDetailsResponse.listingDetails.mrp} product2={p} triggerEvent={this.sendEvent} history={this.props.history} />
							</div>
						)
					})
				}
			</div>
		</div>);
	}

	getInwardedProductsList = () => {
		const { alreadyInwarded, allowedProducts, palletId } = this.state;
		return (
			<div className="top-ten">
				{alreadyInwarded.map((i, index) => {
					let p = {};
					let mOffer = i.listingDetailsResponse.listingDetails.manufacturerOffer;
					if (allowedProducts.length > 0) {
						p = allowedProducts.find((ele) => {
							return i.productInfoResponse.jpin === ele.productListingInformation.productInfoResponse.jpin;
						})

						if (p && p.underProcessQty && p.underProcessQty > 0) {
							i.shortInward = true;
						} else if (p && p.underProcessQty === 0) {
							i.shortInward = false;
						}
					}

					return (
						<div key={index}>
							<ListingProduct product={i} mOffer={mOffer} showQty={true} palletId={palletId} mrp={i.listingDetailsResponse.listingDetails.mrp} product2={p} triggerEvent={this.sendEvent} history={this.props.history} />
						</div>
					)
				})
				}
			</div>
		)
	}

	getDocumentSummary = () => {
		return (
			<div style={{ padding: '20px' }}>
				<div className="text-right" onClick={this.closeDocumentSummary}><img src={close} style={{ height: '22px', width: '22px' }} alt="x" /></div>
				<div style={{ marginTop: '7px' }} className="v-imp-txt">Document Summary</div>
				<div style={{ border: '1px solid #dfdfdf', marginTop: '6px' }}></div>
				<div className="top-ten v-imp-txt">Inwarded Products</div>
				{this.getInwardedProductsList()}
			</div>
		)
	}

	getImageCaoursel = () => {
		const { productToVerify } = this.state;
		if (productToVerify) {
			return <div id="myCarousel" className="carousel slide" data-ride="carousel" style={{ height: '13em' }}>
				<ol className="carousel-indicators" style={{ bottom: '0' }}>
					{productToVerify.productListingInformation.productInfoResponse.imageUrls.map((i, index) => {
						return <li data-target="#myCarousel" data-slide-to={index} className={index === 0 ? "active" : ""} key={index}></li>
					})
					}
				</ol>
				<div className="carousel-inner" role="listbox">
					{productToVerify.productListingInformation.productInfoResponse.imageUrls.map((i, index) => {
						return <div className={index === 0 ? "item active" : "item"} key={index}>
							<img src={i.thumbnail} className="slider-image" alt="product" />
						</div>
					})
					}
				</div>
				<a data-target="#myCarousel" className="left carousel-control" role="button" data-slide="prev" style={{ backgroundImage: 'none' }}>
					<i className="fas fa-chevron-left di-icn"></i>
					<span className="sr-only">Previous</span>
				</a>
				<a data-target="#myCarousel" className="right carousel-control" role="button" data-slide="next" style={{ backgroundImage: 'none' }}>
					<i className="fas fa-chevron-right di-icn"></i>
					<span className="sr-only">Next</span>
				</a>
			</div>
		}
	}

	setNameToValue = (e) => {
		const name = e.target.name;
		let val = e.target.value;

		this.setState({
			[name]: val
		})
	}

	newProdStep1 = () => {
		const { receiveNewProductsReason } = this.state;
		return (
			<div style={{ padding: '20px', textAlign: 'center' }}>
				<div className="dc-num">Please select the reason for adding New Product</div>
				<div style={{ borderBottom: '2px solid #dfdfdf', marginTop: '10px' }}></div>
				<div style={{ display: 'flex', alignItems: 'flex-start', margin: '20px 10px 10px 10px' }}>
					<input type="radio" name="receiveNewProductsReason" id="receiveNewProductsOption1" value={'Freebie'} onChange={(e) => { this.setNameToValue(e) }} style={{ marginRight: '5px' }} />
					<label htmlFor="receiveNewProductsOption1" style={{ textAlign: 'left' }}>Freebie</label>
				</div>
				{/* <div style={{ display: 'flex', alignItems: 'flex-start', margin: '10px' }}>
                    <input type="radio" name="receiveNewProductsReason" id="receiveNewProductsOption2" value={'RTV'} onChange={(e) => { this.setNameToValue(e) }} style={{ marginRight: '5px' }} />
                    <label htmlFor="receiveNewProductsOption2" style={{ textAlign: 'left' }}>Vendor supplied extra product- To be returned to the Vendor</label>
                </div> */}
				<div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '80px' }}>
					<button className="btn" onClick={this.closeReceiveNewProductBox}>Cancel</button>
					<button disabled={!receiveNewProductsReason} className="btn btn-jt-green" onClick={() => this.setState({ receiveNewProductsStep: 2 })}>Proceed</button>
				</div>
			</div>
		)
	}

	passDataToStep3 = (jpin, listingId, title) => {
		console.log(jpin, listingId);
		this.setState({ freebieJpin: jpin, parentListingSelected: listingId, parentListingTitle: title, receiveNewProductsStep: 3 });
	}

	closeReceiveNewProductBox = () => {
		this.setState({ receiveNewProducts: false });
	}

	render() {
		const { allowedProducts, allowedProducts2, selectedSpace, requestOffloadingDone, showDocumentSummary, offloadingDone, palletDropedSuccessfully, noProductFoundWithBarcode, productVerificationBox, productToVerify, productPickerBox, productPickerList, scannedBarcode, inw_open, receiveNewProducts, receiveNewProductsStep, freebieJpin, parentListingSelected, parentListingTitle, vinv, palletId } = this.state;
		const [x, y] = this.getXdividedByY();
		return (
			<div>
				<div className="visible-xs visible-sm">{this.getHeaderBox()}</div>
				{(!selectedSpace && !requestOffloadingDone) ?
					<div>
						<div style={{ backgroundColor: '#F7F4CB', padding: '10px', color: '#BD2E23', display: 'flex', alignItems: 'center' }}>
							<img src={info} style={{ height: '21px', marginRight: '10px' }} alt='Img' />
							<div>
								<div>Please inward only from the selected invoice</div>
								<div>The system will not allow any extra inwards</div>
							</div>
						</div>
						<div className="search-box-outer" style={{ boxShadow: "2px 2px 4px 0px #00000040" }}>
							{(x < y) ?
								<div>
									<Typehead type={'text'} className={'in-mob-box'} placeholder={'Enter Product Name'} id={'product_type_head'} options={allowedProducts2} onSelection={this.onSelection} onPressingEnter={this.enteredPress} valType={'product'} value={'productListingInformation.productInfoResponse.title'} img={'productListingInformation.productInfoResponse.imageUrls.0.thumbnail'} />

									<div className="prdct-srch-sgstn">
										Search products to add to pallet
									</div>
								</div>
								:
								<div className="barcode-send-info">Maximum items received/inwarded for this invoice</div>
							}

						</div>
						<div className="justCent" style={{ padding: '3px', marginTop: '5px' }} >
							<button className="btn-new" onClick={() => {
								this.setState({ receiveNewProducts: !receiveNewProducts, receiveNewProductsStep: 1 });
								this.sendEvent('ON_CLICK_RECIEVE_NON_PO_PRODUCT', { inwarding_session_id: vinv, gric: palletId })
							}}>
								+ Receive New Product (not part of Purchase Order)
							</button>
						</div>
						<div style={{ marginBottom: '20px' }}>
							{this.showAlreadyAddedProduct(x, y)}
						</div>
						<div style={{ margin: '0px 10px 120px 10px', backgroundColor: 'white' }} >
							<div className='v-imp-txt dropdown' style={{ padding: '10px' }} onClick={() => { this.setState({ inw_open: !inw_open }) }}>Already Inwarded Products {inw_open ? <i className="fas fa-chevron-up" style={{ marginLeft: '5px' }}></i> : <i className="fas fa-chevron-down" style={{ marginLeft: '5px' }}></i>} </div>
							<Collapse in={inw_open} >
								<div style={{ padding: '10px' }}>
									{this.getInwardedProductsList()}
								</div>
							</Collapse>
						</div>

						<div className="bottom-btn">
							<div style={{ backgroundColor: '#F7F4CB', padding: '10px 20px', color: '#808080', display: 'flex', justifyContent: 'space-between' }}>
								<div><img src={info} style={{ height: '18px', marginRight: '10px' }} alt='Img' />Remaining items for Inwarding Doc:</div>
								<div style={{ color: 'black' }}>{y - x}</div>
							</div>
							<button className="btn btn-big-drop" onClick={this.showScanningWarning}>Drop Pallet in Inwarding Area</button>
						</div>
					</div> : null
				}
				{(selectedSpace) ? <div>{this.showSpaceWithItems()}</div> : null}
				{(requestOffloadingDone) ? <div>{this.showUploadPOD()}</div> : null}
				<Dialog open={this.state.confirmScanning} maxWidth="lg" fullWidth={true} onClose={this.closeBarcodeBox}>
					<div style={{ padding: '20px', borderRadius: '0' }}>
						<div className="text-right" onClick={this.closeBarcodeBox}><img src={close} style={{ height: '22px', width: '22px' }} alt="x" /></div>
						{this.getSpaceBarcodeEntryRender()}
					</div>
				</Dialog>
				<Dialog open={showDocumentSummary} onClose={this.closeDocumentSummary} fullWidth={true} classes={{ paper: 'document-summary' }}>
					<div>{this.getDocumentSummary()}</div>
				</Dialog>
				<Dialog open={offloadingDone} fullWidth={true} onClose={this.closeOffloadingDone}>
					<div style={{ fontSize: '18px', textAlign: 'center', padding: '10px' }}>
						<div className="text-right" onClick={this.closeOffloadingDone}><img src={close} style={{ height: '22px', width: '22px' }} alt="x" /></div>
						<div className="top-thirty"><img src={filled_tick} alt="success-img" className="top-thirty" style={{ height: '60' }} /></div>
						<div className="top-thirty"><div className="top-thirty">Offloading Successful</div></div>
						<div className="top-thirty"><div className="top-twenty"></div></div>
					</div>
				</Dialog>
				<Dialog open={palletDropedSuccessfully} fullWidth={true} onClose={this.closePalletDropedSuccessfully}>
					<div style={{ fontSize: '18px', textAlign: 'center', padding: '10px' }}>
						<div className="text-right" onClick={this.closePalletDropedSuccessfully}><img src={close} style={{ height: '22px', width: '22px' }} alt="x" /></div>
						<div className="top-thirty"><img src={filled_tick} alt="success-img" className="top-thirty" style={{ height: '60' }} /></div>
						<div className="top-thirty"><div className="top-thirty">Pallet Inwarded Successfully</div></div>
						<div className="top-thirty"><div className="top-twenty"></div></div>
					</div>
				</Dialog>
				<Dialog open={noProductFoundWithBarcode} maxWidth="lg" fullWidth={true} onClose={this.closeNotFoundErrorBox} classes={{ 'paper': 'tw-margn-class' }}>
					<div style={{ padding: '20px', textAlign: 'center' }}>
						<div><img src={barcode_error} alt="product not found" /></div>
						<div className="top-twenty"><div className="error-head-text">No Product Found</div></div>
						<div className="top-ten"><div className="error-desc-text"><div>The barcode didn’t match with</div> <div>any product for this PO.</div> <div>Search the product and add New Barcode</div></div></div>
						<div className="top-thirty"><button className="btn btn-big-norm" onClick={this.closeNotFoundErrorBox}>Okay</button></div>
					</div>
				</Dialog>
				<Dialog open={productPickerBox} maxWidth="lg" onClose={this.closeProductPicker} fullWidth={true} classes={{ paper: 'tw-margn-class' }}>
					<div style={{ padding: '20px' }}>
						<div className="text-right" onClick={this.closeProductPicker}><img src={close} style={{ height: '22px', width: '22px' }} alt="x" /></div>
						<div style={{ marginTop: '7px' }} className="v-imp-txt">Select Product</div>
						<div className="op-nt-imp">This barcode maps to more than one product on the PO. Select the correct one.</div>
						<div style={{ border: '1px solid #dfdfdf', marginTop: '6px' }}></div>
						<div className="top-ten">
							{productPickerList.map((sku, index) => {
								let matched = allowedProducts.find((item) => {
									return item.productListingInformation.productInfoResponse.jpin === sku.jpin;
								})
								if (!matched) {
									return null;
								}
								return (
									<ListingProduct
										key={index}
										product={matched.productListingInformation}
										mrp={sku.mrp}
										mOffer={sku.offerTitle ? { title: sku.offerTitle } : null}
										onClick={() => this.openProductVerification(sku, scannedBarcode)}
									/>
								)
							})}
						</div>
					</div>
				</Dialog>
				<Dialog open={productVerificationBox} maxWidth="lg" fullWidth={true} classes={{ 'paper': 'tw-margn-class' }}>
					<div style={{ padding: '20px', textAlign: 'center' }}>
						{(productToVerify) ?
							<div>
								<div style={{ fontSize: '16px', textAlign: 'left' }}>
									{productToVerify.productListingInformation.productInfoResponse.title}
								</div>
								<div className="top-twenty">
									{this.getImageCaoursel()}
								</div>
								<div style={{ borderTop: '2px solid #dfdfdf', padding: '20px', textAlign: 'center', fontWeight: '600' }}>
									Verify Product
								</div>
								<div>
									<div className="row">
										<div className="col-xs-6">
											<button className="btn btn-big-red" onClick={this.barcodedProductIsWrong}>Wrong Product</button>
										</div>
										<div className="col-xs-6">
											<button className="btn btn-big-green" onClick={this.barcodedProductIsRight}>Correct Product</button>
										</div>
									</div>
								</div>
							</div> : null
						}
					</div>
				</Dialog>
				<Dialog open={receiveNewProducts} maxWidth="lg" fullWidth={true} onClose={this.closeReceiveNewProductBox} classes={{ 'paper': 'tw-margn-class' }}>
					{(receiveNewProductsStep === 1) ?
						<div>{this.newProdStep1()}</div>
						:
						null
					}
					{(receiveNewProductsStep === 2) ?
						<SelectParent onClick={this.passDataToStep3} onClose={this.closeReceiveNewProductBox} vinv={vinv} palletId={palletId} history={this.props.history} triggerEvent={this.sendEvent} />
						:
						null
					}
					{(receiveNewProductsStep === 3) ?
						<SelectFreebie jpin={freebieJpin} onClose={this.closeReceiveNewProductBox} listingId={parentListingSelected} parentListingTitle={parentListingTitle} vinv={vinv} palletId={palletId} history={this.props.history} triggerEvent={this.sendEvent} />
						:
						null
					}
				</Dialog>
				{
					(this.state.error) ?
						<ErrorBox errorText={this.state.error} closeError={this.closeError} /> : null
				}
				{
					(this.state.loading) ?
						<MobLoader /> : null
				}
			</div >
		)
	}
}



// WEBPACK FOOTER //
// ./src/screens/Inwarding/Components/Commons/AddPallet.js